import type { Maybe, ValueEvent } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { AbstractAspect } from '@adornis/filter/aspect-schemas/AbstractAspect.js';
import type { AspectConfig } from '@adornis/filter/filter-options.js';
import '@chancenwerk/components/semantics/chancen-component-semantic-predicate-multi-picker.js';
import type { ChancenRole } from '@chancenwerk/db/semantics/ChancenRole.js';
import { html } from 'lit';

/**
 * @Entity ChancenRoleMultiAspect
 */
@Entity()
export class ChancenRoleMultiAspect extends AbstractAspect {
  static override _class = 'ChancenRoleMultiAspect';

  constructor(doc: PartialEntityData<ChancenRoleMultiAspect>) {
    const newDoc = {
      customID: 'semanticRoles',
      ...doc,
    };
    super(newDoc);
  }

  @Field(type => [ID], { default: v => v ?? [] })
  values!: string[];
  @Field(type => [String], { default: v => v ?? [] })
  names!: string[];
}

export const ChancenRoleMultiAspectSchema: AspectConfig<ChancenRoleMultiAspect> = {
  aspectConstructor: ChancenRoleMultiAspect,
  renderEditor: ({ aspectValue }) => html`
    <chancen-component-semantic-predicate-multi-picker
      @value-picked=${(e: ValueEvent<Maybe<ChancenRole[]>>) => {
        aspectValue.values = e.detail.value?.map(r => r._id) ?? [];
        aspectValue.names = e.detail.value?.map(r => r.readableName ?? '') ?? [];
      }}
      .valueIDs=${aspectValue.values}
    ></chancen-component-semantic-predicate-multi-picker>
  `,
  renderPreview: ({ aspectValue }) => (aspectValue.names.length ? html` ${aspectValue.names.join(', ')} ` : null),
};
